interface Props {
  markOnly?: boolean;
  className?: string;
}

/**
 * TwilioPulse wordmark — small mark + name. The mark is a stylized pulse
 * waveform with a brand-gradient fill on dark.
 */
export function Logo({ markOnly = false, className }: Props) {
  return (
    <span
      className={
        "inline-flex items-center gap-2 text-[15px] font-semibold tracking-tight text-zinc-900 dark:text-zinc-100 " +
        (className ?? "")
      }
    >
      <Mark />
      {!markOnly && <span>TwilioPulse</span>}
    </span>
  );
}

function Mark() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="logo-bg" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#6366f1" />
          <stop offset="1" stopColor="#4338ca" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="20" height="20" rx="6" fill="url(#logo-bg)" />
      <path
        d="M5 12h3l1.5-4 3 8 1.5-4H19"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
